export const ApiPaths = {
    CDM: 'clientdocumentmanagement'
};